import { render, staticRenderFns } from "./purchaseApprovers.vue?vue&type=template&id=fd7520c4&scoped=true"
import script from "./purchaseApprovers.vue?vue&type=script&lang=js"
export * from "./purchaseApprovers.vue?vue&type=script&lang=js"
import style0 from "./purchaseApprovers.vue?vue&type=style&index=0&id=fd7520c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7520c4",
  null
  
)

export default component.exports